export default {"src":"/_next/static/media/plus-circle.c896263e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};